import { useEffect } from "react";
import CrossIcon from "../assets/crossIcon.svg";
const SurveyFormSubmissionInfo = ({ questionDetail, survey, setOpen }) => {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      return (document.body.style.overflow = "auto");
    };
  }, []);
  return (
    <div className="fixed top-0 left-0 h-screen w-screen flex justify-center items-center bg-[#017C5780] z-[1201]">
      <div className="relative w-[80%] h-[80%] bg-white px-10 py-5 rounded-[20px]">
        <div className="absolute right-8 top-5 cursor-pointer ">
          <img
            src={CrossIcon}
            alt="close-popup-icon"
            onClick={() => setOpen(false)}
          />
        </div>
        <div className="h-[95%] overflow-y-scroll mt-[3%]">
          {survey?.surveyparticipantinputs?.map((question, idx) => {
            return (
              <div key={idx} className="mb-2">
                <div className="text-[#191919] font-semibold">
                  {idx + 1 + ". "}
                  {
                    questionDetail[question.questionId]?.questionDetails
                      ?.question
                  }
                </div>

                <div className="text-sm">
                  {questionDetail[
                    question.questionId
                  ]?.questionDetails?.options?.map((option, idx) => {
                    return (
                      <div className="mt-1">
                        {" "}
                        <input
                          type="radio"
                          checked={option === question.answer}
                        />
                        <label htmlFor=""> {option}</label>
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SurveyFormSubmissionInfo;
